import { render, staticRenderFns } from "./WebsiteHeader.vue?vue&type=template&id=bd564460&scoped=true"
import script from "./WebsiteHeader.vue?vue&type=script&lang=js"
export * from "./WebsiteHeader.vue?vue&type=script&lang=js"
import style0 from "./WebsiteHeader.vue?vue&type=style&index=0&id=bd564460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd564460",
  null
  
)

export default component.exports